var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { get, compact } from 'lodash';
import { ContentNode } from './content-node';
import { CellLabel } from '../elements/cell-label';
import { EntityGrid } from './entity-grid';
import { useLang } from '../hooks/use-lang';
var cls = classNames('organisation-view-layout');
export var OrganisationViewLayoutDefaultProps = {
  relatedContentLabel: 'Related Content'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var descriptionStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " 0 ", " 0;\n  "], ["\n    padding: ", " 0 ", " 0;\n  "])), theme.UNIT(6), theme.UNIT(9))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1em;\n    color: ", ";\n    padding-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    color: ", ";\n    padding-bottom: ", ";\n  "])), theme.COLOR('text'), theme.UNIT(4))
});
var RelatedPagesStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Description: styled(ContentNode)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), descriptionStyles),
  Label: styled(CellLabel)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  RelatedPages: styled(EntityGrid)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), RelatedPagesStyles)
};
export var OrganisationViewLayout = function (props) {
  var className = props.className,
    children = props.children,
    relatedContentLabel = props.relatedContentLabel,
    entity = props.entity;
  var openGraph = entity.openGraph,
    _a = entity.feedEntries,
    feedEntries = _a === void 0 ? [] : _a;
  var description = get(openGraph, 'description') || get(entity, 'description');
  var items = compact(__spreadArray([], __read(feedEntries), false));
  var hasItems = !!items.length;
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, !!description && React.createElement(My.Description, {
    entity: description
  }), hasItems && React.createElement(React.Fragment, null, React.createElement(My.Label, null, t(relatedContentLabel)), React.createElement(My.RelatedPages, {
    items: items,
    spacing: 4,
    desktopAutoColumns: 3,
    maxColumns: 3,
    desktopMinColumns: 2
  })), children);
};
OrganisationViewLayout.defaultProps = OrganisationViewLayoutDefaultProps;
OrganisationViewLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;